<template>
 <div id="heftUebersicht">
   <navigation :navigationPlaceholder="navigationPlaceholder"></navigation>
    <b-container fluid class="start-normal" v-for="entry in entries" :key="entry.uid">
      <b-row>
        <b-col cols="12" class="start-container space-b2">
          <div class="subpage-title">
            <h2 class="font-color-red">
              {{ entry.heftUebersichtTitel }}
            </h2>
          </div>
          <div class="text-h3 redactor-with-linkicon" v-html="newLineText(entry.heftUebersichtText)"></div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <template v-for="rel in editions">
            <router-link :to="'/ausgabe/' + rel.slug" class="link-with-linkicon edition-link" :class="'ausgabelink-' + rel.ausgabejahr" :key="rel.uid">
              <span>{{rel.title}}</span> {{rel.ausgabeTitel}} 
              <svg width="15px" height="15px" version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 12 12" style="enable-background:new 0 0 12 12;" xml:space="preserve">
              <title>link-desktop</title>
              <polygon points="3.5,0 3.5,1.5 9.4,1.5 0,11 1,12 10.5,2.6 10.5,8.5 12,8.5 12,0 "/>
              </svg>
            </router-link>
            
          </template>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import Navigation from "@/components/_navigation";
  const axios = require("axios");

  export default {
    name: "HeftUebersicht",
  metaInfo: () => ({
    link: [{ rel: "favicon", href: "favicon.ico" }],
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Femina Politica",
    // all titles will be injected into this template
    description: "Description",
  }),
  components: {
    Navigation,
  },
  data() {
    return {
      entries: [],
      editions: [],
      navigationPlaceholder: "Heft Übersicht"
    };
  },
  created() {
    axios({
      url: "https://craft.femina-politica.de/api",
      method: "POST",
      data: {
        query: `
              query {
                entries(section: "heftUebersicht") {
                  title,
                  uid
                  ... on heftUebersicht_heftUebersicht_Entry {
                    heftUebersichtTitel,
                    heftUebersichtText
                  }
                },
                editions: entries(section: "ausgabe", orderBy: "ausgabejahr DESC") {
                  title,
                  uid,
                  id,
                  url,
                  slug
                  ... on ausgabe_ausgabe_Entry {
                    ausgabejahr
                    ausgabeTitel
                    ausgabeEditorial
                  }
                }
              }
            `,
      },
    }).then((result) => {
      let data = result.data.data.entries;
      console.log(data);

      // assign the fetched data 2 times, once for manipulation
      // once for reseting
      this.entries = data;
      this.entriesToManipulate = data;

      let dataEditions = result.data.data.editions;
      this.editions = dataEditions;
      this.editionsToManipulate = dataEditions;
    });
  },
  methods: {
    newLineText(el){
      if(el){
        return el.replace(/(?:\r\n|\r|\n)/g, "<br />");
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>